import useShipmentLabelDetailsDialog from 'hooks/dialogs/useShipmentLabelDialog';
import usePdfDialog from 'hooks/usePdfDialog';
import React from 'react';
import useConfirmDialog from '../../../hooks/dialogs/useConfirmDialog';
import useGeneralDialog from '../../../hooks/dialogs/useGeneralDialog';
import useInvoiceDetailsDialog from '../../../hooks/dialogs/useInvoiceDetailsDialog';
import useItemsAddedDialog from '../../../hooks/dialogs/useItemsAddedDialog';
import useLiveOrderDetailsDialog from '../../../hooks/dialogs/useLiveOrderDetailsDialog';
import useQuotationActionsDialog from '../../../hooks/dialogs/useQuotationActionsDialog';
import useAddToCompanyDialog from '../../../hooks/useAddToCompanyDialog';
import useFullScreenLoading from '../../../hooks/useFullScreenLoading';
import useInvalidTokenModal from '../../../hooks/useInvalidTokenModal';
import useProfileEditorDialog from '../../../hooks/useProfileEditorDialog';
import InvalidTokenModal from '../../layouts/InvalidTokenModal';
import { FullScreenLoading } from '../../shared/FullScreenLoading';
import AddressesEditorDialog from '../AddressesEditorDialog';
import AddToCompanyDialog from '../AddToCompanyDialog';
import AdminUserAddressesEditorDialog from '../AdminUserAddressesEditor';
import ConfirmDialog from '../ConfirmDialog';
import DocumentEditDialog from '../DocumentEditDialog';
import DocumentUploadDialog from '../DocumentUploadDialog';
import GeneralDialog from '../GeneralDialog';
import InvoiceDetailsDialog from '../InvoiceDetailsDialog';
import ItemsAddedDialog from '../ItemsAddedDialog';
import LiveOrderDetailsDialog from '../LiveOrderDetailsDialog';
import ProfileEditorDialog from '../ProfileEditorDialog';
import QuotationDialog from '../QuotationDialog/QuotationDialog';
import ShipmentLabelDetailsDialog from '../ShipmentLabelDetailsDialog';

const ModalWrapper: React.FC = () => {
    const invalidTokenModal = useInvalidTokenModal();
    const profileDialog = useProfileEditorDialog();
    const addToCompanyDialog = useAddToCompanyDialog();
    const fullScreenLoading = useFullScreenLoading();
    const confirmDialog = useConfirmDialog();
    const invoiceDetailsDialog = useInvoiceDetailsDialog();
    const quotationActionsDialog = useQuotationActionsDialog();
    const itemsAddedDialog = useItemsAddedDialog();
    const liveOrderDetailsDialog = useLiveOrderDetailsDialog();
    const generalDialog = useGeneralDialog();
    const shipmentLabelDetailsDialog = useShipmentLabelDetailsDialog();
    const pdfDialog = usePdfDialog();

    return (
        <>
            <ProfileEditorDialog
                open={profileDialog.profileEditorStates.profile.open}
            />
            <AddressesEditorDialog
                open={profileDialog.profileEditorStates.address.open}
            />
            <AdminUserAddressesEditorDialog
                open={profileDialog.profileEditorStates.adminAddress.open}
            />
            <AddToCompanyDialog
                open={addToCompanyDialog.addToCompanyDialogState.open}
            />
            {fullScreenLoading.fullScreenLoadingStates && <FullScreenLoading />}
            <InvalidTokenModal open={invalidTokenModal.show} />
            <ConfirmDialog dialogContent={confirmDialog.dialogContent} />
            <InvoiceDetailsDialog open={invoiceDetailsDialog.open} />
            {quotationActionsDialog.dialog.open && <QuotationDialog />}
            {itemsAddedDialog.open && <ItemsAddedDialog />}
            <LiveOrderDetailsDialog open={liveOrderDetailsDialog.open} />
            {generalDialog.open && <GeneralDialog />}
            <ShipmentLabelDetailsDialog
                open={shipmentLabelDetailsDialog.open}
            />
            <DocumentUploadDialog
                open={pdfDialog.pdfDialogStates.pdfUploadDialog.open}
            />
            <DocumentEditDialog
                open={pdfDialog.pdfDialogStates.pdfEditDialog.open}
                document={pdfDialog.pdfDialogStates.pdfEditDialog.document}
            />
        </>
    );
};

export default ModalWrapper;
